import React from 'react';
import PropTypes from 'prop-types';
import OpenDatePicker from '~/Components/Global/DatePicker/OpenDatePicker';
import '~/Components/Global/ChecklistsDisplay/TaskDatePicker.scss';
import { darkGray } from '~/Styles/Colors.js';

const CustomPrevious = () => (
  <span className="material-icons-outlined custom-datepicker-nav custom-datepicker-nav--prev">
    chevron_left
  </span>
);

const CustomNext = () => (
  <span className="material-icons-outlined custom-datepicker-nav custom-datepicker-nav--next">
    chevron_right
  </span>
);

const TaskDatePicker = ({ selected, onChange, openToDate, defaultCalendarColor, ...rest }) => {
  const formatShortWeekday = name => name.substring(0, 1);

  return (
    <div
      className="task-date-picker"
      style={{
        '--default-calendar-color': defaultCalendarColor || darkGray,
      }}
    >
      <OpenDatePicker
        selected={selected}
        onChange={onChange}
        openToDate={openToDate}
        {...rest}
        formatWeekDay={formatShortWeekday}
        renderCustomHeader={({
          date,
          changeYear,
          changeMonth,
          decreaseMonth,
          increaseMonth,
          prevMonthButtonDisabled,
          nextMonthButtonDisabled,
        }) => {
          const currentDate = new Date(date);

          return (
            <div className="custom-header">
              <button
                aria-label="Previous Month"
                onClick={decreaseMonth}
                disabled={prevMonthButtonDisabled}
                className="custom-header-button"
                type="button"
              >
                <CustomPrevious />
              </button>
              <div className="month-year">
                {currentDate.toLocaleDateString('default', { month: 'long' })}{' '}
                {currentDate.getFullYear()}
              </div>
              <button
                aria-label="Next Month"
                onClick={increaseMonth}
                disabled={nextMonthButtonDisabled}
                className="custom-header-button"
                type="button"
              >
                <CustomNext />
              </button>
            </div>
          );
        }}
      />
    </div>
  );
};

TaskDatePicker.propTypes = {
  selected: PropTypes.object,
  onChange: PropTypes.func,
  openToDate: PropTypes.object,
  defaultCalendarColor: PropTypes.string,
};

export default TaskDatePicker;
